import { AfterViewInit, Component, EventEmitter, HostBinding, HostListener, Input, OnInit, Output } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export type TabHeader = {
  label: string
}

@Component({
  selector: 'kt-tab-header-v2',
  templateUrl: `./tab-header.component.html`,
  styleUrls: ['./tab-header.component.scss']
})
export class TabHeaderComponent implements OnInit, AfterViewInit {
  // Headers
  private _headers$ = new BehaviorSubject<Array<TabHeader>>([])
  headers$ = this._headers$.asObservable()
  @Input()
  set headers(value: TabHeader[]) {
    this._headers$.next(value)
  }

  @Input() innerTop: string = null;

  @Input() 
  set selectedTabIndex(index: number) {
    this.selectedIndex = index;
  }

  @Output() tabChange = new EventEmitter<number>()


  @HostBinding('style.top') top = '0px';
  @HostListener('window:resize', ['$event'])
  onResize() {
    if (this.innerTop) {
      this.top = this.innerTop
      return;
    }
    this.updateStickyPosition()
  }
  @HostListener('window:scroll', ['$event'])
  onScroll() {
    if (this.innerTop) {
      this.top = this.innerTop
      return
    }
    this.updateStickyPosition()
  }

  selectedIndex: number = 0

  onHeaderClick(index: number) {
    this.selectedIndex = index
    this.tabChange.emit(index)
  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    if (this.innerTop) {
      this.top = this.innerTop
      return
    }
    this.updateStickyPosition()
  }

  private updateStickyPosition() {
    const topHeaderElement = document.querySelector('.header') as HTMLElement;
    const ktPortletHeaderElement = document.getElementsByTagName('kt-portlet-header').item(0) as HTMLElement;

    let height = 0;
    if (topHeaderElement != null) {
      height += topHeaderElement.offsetHeight
    }
    if (ktPortletHeaderElement != null) {
      height += ktPortletHeaderElement.offsetHeight
    }

    this.top = height + 'px'
  }
}